import initialState from '../initialstate';
import {REJECT_TASK, ACCEPT_TASK} from '../../actions/actiontypes';
export default function rejectTaskReducer(state = initialState.rejectedTask, action) {
	switch (action.type) {
		case REJECT_TASK: {
			return state;
		}
		default:
			return state;
	}
}

export function acceptTaskReducer(state = initialState.acceptedTask, action) {
	switch (action.type) {
		case ACCEPT_TASK: {
			return state;
		}
		default:
			return state;
	}
}
